export default {
  headers: [
    {
      text: 'User ID',
      value: 'id',
    },
    {
      text: 'Admin',
      value: 'admin',
    },
    {
      text: 'User',
      value: 'user',
    },
    {
      text: 'Support User',
      value: 'support',
    },
    {
      text: 'Actions',
      value: 'actions',
      sort: false,
    },
  ],
  options: {
    loadingText: 'Loading roles... Please wait',
    showSelect: true,
    itemsPerPage: 10,
  },
  bulkActionItems: [{
    title: 'Delete',
    id: 'deleteMultiple',
    action: 'onMulitpleDelete',
  }],
};
